import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ConfigProvider } from './context/ConfigContext';
import Layout from './components/layout/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Animais from './pages/Animais';
import Pesagens from './pages/Pesagens';
import Amamentacao from './pages/Amamentacao';
import Lotes from './pages/Lotes';
import Intervencoes from './pages/Intervencoes';
import Famacha from './pages/Famacha';
import Coberturas from './pages/Coberturas';
import Partos from './pages/Partos';
import IndicadoresRepro from './pages/IndicadoresRepro';
import Estoque from './pages/Estoque';
import Agenda from './pages/Agenda';
import Descartes from './pages/Descartes';
import Relatorios from './pages/Relatorios';
import Configuracoes from './pages/Configuracoes';
import Racoes from './pages/Racoes';
import RelatorioGMD from './pages/RelatorioGMD';
import IndicadoresZootecnicos from './pages/IndicadoresZootecnicos';
import FluxoCaixa from './pages/FluxoCaixa';
import Vendas from './pages/Vendas';

function PrivateRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  return user ? <Layout>{children}</Layout> : <Navigate to="/login" />;
}

export default function App() {
  return (
    <AuthProvider>
      <ConfigProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
            <Route path="/animais" element={<PrivateRoute><Animais /></PrivateRoute>} />
            <Route path="/pesagens" element={<PrivateRoute><Pesagens /></PrivateRoute>} />
            <Route path="/amamentacao" element={<PrivateRoute><Amamentacao /></PrivateRoute>} />
            <Route path="/lotes" element={<PrivateRoute><Lotes /></PrivateRoute>} />
            <Route path="/intervencoes" element={<PrivateRoute><Intervencoes /></PrivateRoute>} />
            <Route path="/famacha" element={<PrivateRoute><Famacha /></PrivateRoute>} />
            <Route path="/coberturas" element={<PrivateRoute><Coberturas /></PrivateRoute>} />
            <Route path="/partos" element={<PrivateRoute><Partos /></PrivateRoute>} />
            <Route path="/indicadores-repro" element={<PrivateRoute><IndicadoresRepro /></PrivateRoute>} />
            <Route path="/estoque" element={<PrivateRoute><Estoque /></PrivateRoute>} />
            <Route path="/racoes" element={<PrivateRoute><Racoes /></PrivateRoute>} />
            <Route path="/agenda" element={<PrivateRoute><Agenda /></PrivateRoute>} />
            <Route path="/descartes" element={<PrivateRoute><Descartes /></PrivateRoute>} />
            <Route path="/relatorios" element={<PrivateRoute><Relatorios /></PrivateRoute>} />
            <Route path="/relatorios/gmd" element={<PrivateRoute><RelatorioGMD /></PrivateRoute>} />
            <Route path="/indicadores" element={<PrivateRoute><IndicadoresZootecnicos /></PrivateRoute>} />
            <Route path="/fluxo-caixa" element={<PrivateRoute><FluxoCaixa /></PrivateRoute>} />
            <Route path="/vendas" element={<PrivateRoute><Vendas /></PrivateRoute>} />
            <Route path="/configuracoes" element={<PrivateRoute><Configuracoes /></PrivateRoute>} />
          </Routes>
        </BrowserRouter>
      </ConfigProvider>
    </AuthProvider>
  );
}
